import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

// UTILITY
import {
  getSecureCardNumberValue,
  formatCardExpValue,
  formatSubscriptionDate,
} from '@/utility/subscription';

// STYLES
import { SBillingDetails } from './styles';

function BillingDetails({ card, endDate, className }) {
  const [t] = useTranslation();

  const cardNumberValue = getSecureCardNumberValue(card.last4);
  const cardExpValue = formatCardExpValue(card.exp_month, card.exp_year);
  const nextBillingDate = formatSubscriptionDate(endDate);

  return (
    <SBillingDetails className={className}>
      <div className="billing-item-wrapper">
        <div className="card-info-wrapper">
          <Typography className="p4">{t('inputs.creditCard')}:</Typography>
          <Typography variant="h6">{cardNumberValue}</Typography>
        </div>
        <div>
          <Typography className="p4">{t('inputs.expDate_short')}:</Typography>
          <Typography variant="h6">{cardExpValue}</Typography>
        </div>
      </div>
      <div className="billing-item-wrapper">
        <div>
          <Typography className="p4">{t('inputs.nextBillingDate')}:</Typography>
          <Typography variant="h6">{nextBillingDate}</Typography>
        </div>
      </div>
    </SBillingDetails>
  );
}

BillingDetails.defaultProps = {
  className: '',
};

BillingDetails.propTypes = {
  card: PropTypes.object.isRequired,
  endDate: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default BillingDetails;
